import React, { useEffect, useCallback, Suspense, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch, Route, BrowserRouter as Router, Redirect }  from 'react-router-dom';
import _ from 'lodash';
import jwtDecode from 'jwt-decode';
import cookie from 'cookie_js';
import { stringIsNullOrUndefinedOrBlank, isNullOrUndefined } from './utils/siteFunctions';
import { refreshCustomerClientPortalSettings, resetCustomer, setInitialCheckForAuthenticationCompleted, setUser, getClient, setClient } from './store/reducers/ui/actions';
import PopupMessages from './components/controls/PopupMessages';
// import { UserState } from './@types/ui/ui';


import Layout from './components/Layout';

import AuthorizeRoute from './utils/AuthorizeRoute';

// import ProtectedHome from './pages/ProtectedHome';
import LoginPage from './pages/LoginPage';
import AccountsPage from './pages/AccountsPage';
import EnterAccountsPage from './pages/EnterAccountsPage';
import ReportsPage from './pages/ReportsPage';
import RemindersPage from './pages/RemindersPage';
import UploadToAgencyPage from './pages/UploadToAgencyPage';
import LoadingPage from './pages/LoadingPage';

import { ApplicationState } from './store';
import Loadingpage from './pages/LoadingPage';

const App = () => {
	/// Hooks
	const dispatch = useDispatch();

	/// Global State
	const user = useSelector(state => state.ui.user);
	const client = useSelector(state => state.ui.client);
	const customer = useSelector(state => state.ui.customer);
	const initialCheckForAuthenticationCompleted = useSelector(state => state.ui.initialCheckForAuthenticationCompleted);

	/// Effects
	useEffect(() => {
		if (!initialCheckForAuthenticationCompleted) {
			const encodedJwt = cookie('simplicity-client-portal-jwt');
			const jwtIsEmpty = stringIsNullOrUndefinedOrBlank(encodedJwt);
			const userIsEmpty = isNullOrUndefined(user);

			let promiseChain = Promise.resolve();

			if (jwtIsEmpty) {
				if (!userIsEmpty)
					promiseChain = promiseChain.then(() => dispatch(setUser(null)));

				if (!isNullOrUndefined(client))
					promiseChain = promiseChain.then(() => dispatch(setClient(null)));
			}
			else if (userIsEmpty) {
				const jwt:any = jwtDecode(encodedJwt);

				promiseChain = promiseChain.then(() => dispatch(setUser({ username: jwt.username })));
				promiseChain = promiseChain.then(() => dispatch(refreshCustomerClientPortalSettings(parseInt(jwt.pin))));
				promiseChain = promiseChain.then(() => dispatch(getClient()));
			}

			promiseChain = promiseChain.then(() => dispatch(setInitialCheckForAuthenticationCompleted(true)));
		}
	}, [user, dispatch, customer, initialCheckForAuthenticationCompleted, client]);

	/// Render
	return (
		<>
			<Suspense fallback={<div><span>Loading...</span><div></div></div>}>
				<Router>
					<Switch>
						{ !initialCheckForAuthenticationCompleted && <Route path="/"><LoadingPage /></Route> }
						<AuthorizeRoute path="/Accounts/:acctNumber?">
							<Layout><AccountsPage /></Layout>
						</AuthorizeRoute>
						<AuthorizeRoute exact path='/EnterAccounts'>
							<Layout><EnterAccountsPage /></Layout>
						</AuthorizeRoute>
						<AuthorizeRoute exact path='/Reports'>
							<Layout><ReportsPage /></Layout>
						</AuthorizeRoute>
						<AuthorizeRoute exact path='/Reminders'>
							<Layout><RemindersPage /></Layout>
						</AuthorizeRoute>
						<AuthorizeRoute exact path='/UploadToAgency'>
							<Layout><UploadToAgencyPage /></Layout>
						</AuthorizeRoute>
						<Redirect exact from="/UploadToAccount" to="/Accounts?uploadAccountFiles" />
						{
							isNullOrUndefined(user)
								? (
									<Route exact path="/">
										<LoginPage />
									</Route>
								)
								: <Redirect exact from="/" to='/Accounts' />
						}
					</Switch>
				</Router>
			</Suspense>
			<PopupMessages />
		</>
	);
};

export default App;